import { render, staticRenderFns } from "./GogoReliable.vue?vue&type=template&id=2019f4b5&scoped=true"
var script = {}
import style0 from "./GogoReliable.vue?vue&type=style&index=0&id=2019f4b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2019f4b5",
  null
  
)

export default component.exports